export default {
  addItem: {
    margin: 10,
  },
  addItemContainer: {
    textAlign: 'right',
  },
  body: {
    padding: 10,
  },
  stageIcon: {
    height: 30,
    width: 30,
  },
  iconCol: {
    width: 80,
  },
  nameCol: {},
  typeCol: {
    width: 120,
  },
  qualityControlCol: {
    width: 120,
  },
  actionCol: {
    width: 120,
  },

  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 180,
    color: 'lightgrey',
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/JobProfiles/StagesGrid/styles.js